/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react';
import OocyteSelector from './occyteSelector';
import DetailsTable from './detailsTable';
import { actionOptionsLocalized, actionsItems,cryoPurposeOptionsLocalized,EmbryoDetail, EmbryoOocyteFilledStatus, fertilizationItems, FreezeDialogValues, freezelocationDetails, incubatorItems, initialValuesCryo, pgtOrderBiopsyCellsItems, pgtorderDetailsItems, pgtResultEmbryoSexItems, pgtResultMoistureItems, pgtResultsItems, source_list, storeGobletColor, symmetryItems, UpdateEmbryo } from './embryoCulture.helpers';
import { useIncubatorsDropdown } from './embryoCulture.helpers';
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid2, IconButton, TextField, ThemeProvider, Typography } from '@mui/material';
import styles from './embryoCulture.module.css';
import { theme } from '../../../components/Medical_History_Forms/themeprovider';
import { Form } from 'react-router-dom';
import { Formik, FormikErrors, FormikHelpers, getIn } from 'formik';
import { capitalizeTitle, convertUnderscoreToTitle, getCurrentTimeHHMM, getLocalizedLabelByCode, RequiredLabel } from '../../../utils/commonUtils';
import { Clinician, fetchIncubators, IncubatorObject, mediaOptionsLocalized, Role, ROLES } from '../Occyte-Grading/oocyteGrading.helper';
import { useClinic } from '../../../components/ClinicProvider';
import { useAlert } from '../../../components/alertProvider';
import { useLoader } from '../../../components/loaderProvider/loader';
import { getUsersByClinicId } from '../../../services/apiService';
import ImageUploadComponent from '../../../components/Surgery/laparoscopy/imageUploadLaparoscopy';
import { ConfirmationModal } from '../../../components/confirmationModal';
import { CombinedValidationSchema, EmbryoCultureType, EmbryoFinilizeUpdateType, EmbryoUpdateDetailsType, getColumns , getEmbryoCultureDetails, initialEmbryoCultureValues, initialEmbryoUpdateDetailsValues, updateEmbryoCulture, updateEmbryoSummary, getPgtaFacilityDetails } from './dayThirdHelper';
import { AxiosError } from 'axios';
import GradingUnavailable from '../Occyte-Grading/oocyteGradingUnavailable';
import FreezeActionDialog from './freezeActionDialog';
import EmbryoCultureViewMode from './ViewMode';
import OverlayIconPanel from './overlay';
import EmbryoFileUpload from './EmbryoFileUpload';
import EmbryoMultiImageUploadDialog from './EmbryoMultiImageUploadDialog';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

import VisibilityIcon from '@mui/icons-material/Visibility';
import { EmbryoDetailsMasters } from './dayFirst.helpers';
import { useTranslation } from 'react-i18next';
import { getButtonStates } from '../../../utils/permissionService';
import { getFreezeSlotProps  } from '../../../utils/getFreezeSlotProps';
interface cycleProp {
    initialCycleId: number;
    dropDownMaster : EmbryoDetailsMasters; 
  }

  
const DayThird:React.FC<cycleProp> = ({ initialCycleId,dropDownMaster }) => {
  const { t: tGeneral, i18n } = useTranslation('general');
  const { t: tCulture } = useTranslation('culture_config');
  const language = i18n.language;

  const { ClinicId } = useClinic();
  const { addAlert } = useAlert();
  const { showLoader, hideLoader } = useLoader();
  const [file, setFile] = useState<File | null>(null); 
  const [imagePathUrl, setImagePathUrl] = useState<string | null>(null);
  const [selectedEmbryos, setSelectedEmbryos] = useState<number[]>([]);
  const [allEmbryos, setAllEmbryos] = useState<EmbryoDetail[]>([]);
  const [selectedSource, setselectedSource] = useState<string>('');
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [rows, setRows] = useState<any[]>([]);
  const [actionStatus, setActionStatus] = useState<'DRAFT' | 'FINALIZED'>('DRAFT');
  const [embryoCulture, setEmbryoCulture] = useState<EmbryoCultureType>(initialEmbryoCultureValues);
  const [embryoDetails, setEmbryoDetails] = useState<EmbryoUpdateDetailsType>(initialEmbryoUpdateDetailsValues);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isFreezeDialogOpen, setFreezeDialogOpen] = useState(false);
  const [hitSubmitbtn, setHitSubmitbtn] = useState(false);
  const [embryosFound, setEmbryosFound] = useState<boolean>(true); 
  
  const [areAllOocytesFilled, setAreAllOocytesFilled] = useState(false);
  const [isFinalizeConfirmDialogOpen, setFinalizeConfirmDialogOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<{ embryo_no: number; base64: string }[]>([]);
  const [isEmbryoUploadDialogOpen, setEmbryoUploadDialogOpen] = useState(false);
  const [freezeLocations, setFreezelocations]= useState<freezelocationDetails[]|null>(null);
  const { canAdd , canEdit, canView} = getButtonStates('Lab', 'Embryo Culture', 'Day 3', 'female');
  // Use reusable incubator dropdown hook
  const [incubatorsDropdown, refreshIncubators] = useIncubatorsDropdown('Embryo');

  useEffect(() => {
    refreshIncubators();
  }, [tGeneral, refreshIncubators]);

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const [isPGTResultDialogOpen, setIsPGTResultDialogOpen] = useState(false);

  const handlePGTResultDialogClose = () => {
    setIsPGTResultDialogOpen(false);
  };
  // Initialize state for clinician lists
  const [clinicianLists, setClinicianLists] = useState<Record<Role, Clinician[]>>({
    DOCTOR: [],
    ANESTHETIST: [],
    EMBRYOLOGIST: [],
    NURSE: [],
  });
  
  
  const [isTableDeletable, setIsTableDeletable] = useState(true);
  const [showViewMode, setShowViewMode] = useState(false);

  const [freezeValues, setFreezeValues] = useState<FreezeDialogValues>(initialValuesCryo);
  
  
  const [selectedCycleId, setSelectedCycleId] = useState<number>(initialCycleId);
  const [sourceData, setSourceData] = useState<source_list[]>([]);
  const [selectedSourceId, setSelectedSourceId] = useState<number | null>(null);
  const [selectedThawId, setSelectedThawId] = useState<number | null>(null);
  const [allSourceEmbryos, setAllSourceEmbryos] = useState<UpdateEmbryo[]>([]);
  const [facilityItems, setFacilityItems] = useState<{ label: string; value: number }[]>([]);
  const [selectedFacility, setSelectedFacility] = useState<{ id: number; name: string; result_fields: string[] } | null>(null);
  const [detailFound, setDetailFound] = useState<boolean>(false);


  const fetchEmbryoDetails = useCallback(
    (cycle_id: number,  sourceID?: number, thawId?:number | null) => {
      showLoader();
      if (cycle_id) {
        getEmbryoCultureDetails(cycle_id, sourceID, thawId) 
          .then((data) => {

            if (data.embryo && data.embryo.length === 0) {

              setEmbryosFound(false); 
            } else {
              setEmbryosFound(true); 
            }

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const embryoDetails = data.embryo.map((detail: any) => ({
              embryo_number: detail.embryo_number,
              isFilled: detail.action !== null,
            }))
              .sort((a: { embryo_number: number; }, b: { embryo_number: number; }) => a.embryo_number - b.embryo_number);
            setAllEmbryos(embryoDetails);
            
            const opuDate = data?.details[0].opu_date;
            const thawDate = data?.details[0].thaw_date;
            
            const adjustedDate = opuDate
              ? new Date(new Date(opuDate).getTime() + 3 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
              : thawDate 
                ? new Date(thawDate).toISOString().split('T')[0]
                : new Date().toISOString().split('T')[0];

            setEmbryoCulture((prevEmbryoCulture) => ({
              ...prevEmbryoCulture,  
              ...data?.details[0], 
              opu_date: adjustedDate       
            }));
         
            const found = !!(data?.details && data.details[0] && data.details[0].embryologist);
            setDetailFound(found);
          })
          .catch((error) => {
            console.error('Error fetching Embryo Details:', error);

            // If error occurs, reset to initial/default values
            // setEmbryoCulture({});
            // setEmbryoDetails({});
          })
          .finally(() => {
            hideLoader();
          });
      }
    },
    [showLoader, hideLoader]
  );


  
  const fetchSourceList = useCallback((isdeletetriggered?:boolean)=>{
    showLoader();
    getEmbryoCultureDetails(selectedCycleId)
      .then((data) => {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        processEmbryoData(data,selectedSourceId, selectedThawId );
        // Check if source_list exists before updating state
        if (data && Array.isArray(data.source_list)) {
          setSourceData(data.source_list);
          // Set the first object's source as the selectedSourceId if sourceData is not empty
          if (data.source_list.length > 0) {
    
            const firstSourceId = data.source_list[0].source;
            const FirstThawId = data.source_list[0].thaw_cycle;
            setselectedSource(data.source_list[0].name);
            setSelectedSourceId(firstSourceId);
            setSelectedThawId(FirstThawId);
            // Call fetchEmbryoDetails with the first source ID
            fetchEmbryoDetails(selectedCycleId, firstSourceId, FirstThawId);
          }
          setAllSourceEmbryos(data.embryo);

          const finalizedItem = data.embryo?.every((item: EmbryoUpdateDetailsType) => item.status === 'FINALIZED');            
          setIsTableDeletable(finalizedItem);
          if (!isdeletetriggered) {
            
            const showViewMode = data.embryo?.some((item: EmbryoUpdateDetailsType) => item.action !== null);
            setShowViewMode(showViewMode);
                    
          } else {
            setShowViewMode(false);
          }     
 
          const embryoDetails = data.embryo
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((detail: any) => ({
              embryo_number: detail.embryo_number,
              isFilled: detail.action !== null,
            }))
            .sort((a: { embryo_number: number; }, b: { embryo_number: number; }) => a.embryo_number - b.embryo_number);
                            
          if (embryoDetails.length >= 1) {
            const isAllFilled = embryoDetails.every((embryo: EmbryoOocyteFilledStatus) => embryo.isFilled);
                        
            if (!isAllFilled) {
              setAreAllOocytesFilled(false);
            } else {
              setAreAllOocytesFilled(true);
            }
          } else {
            setAreAllOocytesFilled(false);
          }            
        }
      })
      .catch((error) => {
        console.error('Error fetching source list:', error);
      }).finally(()=>{
        hideLoader();
      });
    // eslint-disable-next-line
  },[]);
  
  useEffect(() => {
    fetchSourceList();
    // eslint-disable-next-line
  }, [selectedCycleId]);
    
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const processEmbryoData = (data:any, selectedSourceId:number |null |undefined, selectedThawId:number |null |undefined) => {

    if (data.details && Array.isArray(data.details) && !selectedSourceId && !selectedThawId) {
      const mappedRows = data.embryo
      // eslint-disable-next-line @typescript-eslint/no-explicit-any 
        .filter((item: any) => item.action !== null).sort((a: any, b: any) => a.embryo_number - b.embryo_number).map((item: any) => {
          const pgtOrderContent = item.pgt_order && 
          Object.values(item.pgt_order).some(value => value !== null && value !== undefined)
            ? {
              title: tGeneral('pgtOrderDetailsTitle', { defaultValue: 'PGT Order Details' }),
              details: [
                { label: tGeneral('date', { defaultValue: 'Date' }), value: item.pgt_order.pgt_order_date || '-' },
                {
                  label: tGeneral('time', { defaultValue: 'Time' }),
                  value: item.pgt_order.pgt_order_time
                    ? new Date(`1970-01-01T${item.pgt_order.pgt_order_time}`).toLocaleString('en-US', {
                      hour: 'numeric',
                      minute: '2-digit',
                      hour12: true,
                    })
                    : '-',
                },
                { label: tGeneral('cellBiopsy', { defaultValue: '# Cell Biopsy' }), value: convertUnderscoreToTitle(item.pgt_order.pgt_order_biopsy_cells) || '-' },
                { label: tGeneral('facility', { defaultValue: 'Facility' }), value: convertUnderscoreToTitle(item.pgt_order.pgt_facility) || '-' },
                { label: tGeneral('pgtType', { defaultValue: 'PGT Type' }), value: convertUnderscoreToTitle(item.pgt_order.pgt_type) || '-' },
              ],
            }
            : null;


          const freezeContent = item.action === 'FREEZE'
            ? {
              title: tGeneral('actionInfoTitle', { defaultValue: 'Action Information' }),
              details: [
                { label: tGeneral('cryoPreservedDate', { defaultValue: 'Cryo Preserved Date' }), value: item.cryo_preserved_date ?? '-' },
                { label: tGeneral('cryoPreservedBy', { defaultValue: 'Cryo Preserved By' }), value: item.cryo_preserved_by_name ?? '-' },
                { label: tGeneral('cryoPurpose', { defaultValue: 'Cryo Purpose' }), value: getLocalizedLabelByCode(cryoPurposeOptionsLocalized, item.cryo_purpose, language) ?? '-' },
                { label: tGeneral('media', { defaultValue: 'Media' }), value: getLocalizedLabelByCode(mediaOptionsLocalized, item.cryo_media, language) ?? '-' },
                { label: tGeneral('screeningStatus', { defaultValue: 'Screening Status' }), value: item.is_screened ? tGeneral('yes', { defaultValue: 'Yes' }) : tGeneral('no', { defaultValue: 'No' }) },
              ],
            } 
            : null;
          
          const pgtResultContent = item.pgt_results &&
              Object.entries(item.pgt_results).some(([key, value]) =>
                value !== null &&
                value !== undefined &&
                (key !== 'pgt_result_notes' || value !== '')
              )
            ? {
              title: tGeneral('PGTResult', { defaultValue: 'PGT Result'}),
              details: Object.entries(item.pgt_results).map(([key, value]) => ({
                label: capitalizeTitle(key),
                value: value !== undefined && value !== null && value !== ''
                  ? capitalizeTitle(String(value))
                  : '-',
              })),
            }
            : null;
          
          return {
            id: item.id,
            embryoNo: item.embryo_no,
            image: item?.files[0]?.file,
            spermSource: item.sperm_source || '-',
            inseminationTechnique: item.insemination_technique || '-',
            action: item.action === 'FREEZE' && freezeContent ?( 
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <OverlayIconPanel content={freezeContent} />
                <span style={{ marginLeft: '5px' }}>{getLocalizedLabelByCode(actionOptionsLocalized, item.action, language) }</span>
              </div>): getLocalizedLabelByCode(actionOptionsLocalized, item.action, language) ,
            freezeLocation: item.location || '-',
            location_details:item.location_details || null,
            grade: item.grade || '-',
            symmetry: item?.symmetry_label || '-',
            no_of_Cells: item?.number_of_cells_label || '-',
            multinuclei: item?.multi_nuclei_label || '-',
            pgtOrderDetails: pgtOrderContent ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <OverlayIconPanel content={pgtOrderContent} />
                <span style={{ marginLeft: '5px' }}> {tGeneral('yes', { defaultValue: 'Yes' })} </span>
              </div>
            ) : (
              tGeneral('no', { defaultValue: 'No' })
            ),

            pgtResult: pgtResultContent ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <OverlayIconPanel content={pgtResultContent} />
                <span style={{ marginLeft: '5px' }}>{tGeneral('yes', { defaultValue: 'Yes' })}</span>
              </div>
            ) : (
              tGeneral('no', { defaultValue: 'No' })           
            ),
            embryo_number: item.embryo_number,
          };
        });
    
      setRows(mappedRows);
    }
  };

  // Handle dropdown change using SelectChangeEvent type
  const handleSourceChange = (event: string) => {
    const selectedSOurceName = event;
    const selectedSourceItem = sourceData.find(item => item.name === selectedSOurceName) || null;
    // Log the selected source item
    setselectedSource(selectedSOurceName); // Update selectedSourceId as well
      
    // Use a default value if cycle is undefined
    const cycle_ID = selectedSourceItem?.cycle ?? 0; 
    setSelectedCycleId(cycle_ID);
      
    setSelectedSourceId(selectedSourceItem?.source ?? 0);
    setSelectedThawId(selectedSourceItem?.thaw_cycle ?? null);
      
    if (selectedSourceItem) {
      fetchEmbryoDetails(cycle_ID, selectedSourceItem.source, selectedSourceItem.thaw_cycle); 
    } 
  };
        
  const handleSelectionChange = (newSelectedOocytes: number[], newDropdownValue: string) => {    
    setSelectedEmbryos(newSelectedOocytes);
    if (selectedSource && selectedSource !== newDropdownValue) {      
      setselectedSource(newDropdownValue);
      handleSourceChange(newDropdownValue);
    };
  };

  // useEffect(() => {
  //   fetchEmbryoDetails(selectedCycleId);
  // }, [fetchEmbryoDetails, selectedCycleId]);  
  
  // Wrap fetchCliniciansByRole in useCallback
  const fetchCliniciansByRole = useCallback((role: Role) => {
    showLoader();
    const query = `clinic=${ClinicId}&role=${role}`;
    getUsersByClinicId(query)
      .then((res) => {
        setClinicianLists(prev => ({
          ...prev,
          [role]: res?.objects ?? [],
        }));
      })
      .catch((error) => {
         
        console.error(`Error fetching ${role.toLowerCase()}s:`, error);
      })
      .finally(() => {
        hideLoader();
      });
  }, [ClinicId, showLoader, hideLoader]); // Add dependencies here
  

  
  // In fetchFacilityDetails, also store the full objects for lookup
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [facilityObjects, setFacilityObjects] = useState<any[]>([]);
  const fetchFacilityDetails = useCallback(() => {
    showLoader();
    const query = {};
    getPgtaFacilityDetails(query)
      .then((res) => {
        const objectsArray = Array.isArray(res?.objects) ? res.objects : [];
        setFacilityObjects(objectsArray); // Store full objects
        const facilities = objectsArray.map((facility: { id: number; name: string }) => ({
          label: facility.name,
          value: facility.id,
        }));
        setFacilityItems(facilities);
      })
      .catch((error) => {
        console.error('Error fetching PGT facilities:', error);
      })
      .finally(() => {
        hideLoader();
      });
  }, [ showLoader, hideLoader]);
  
  
  // Fetch clinicians for each role on component mount or when ClinicId changes
  useEffect(() => {
    ROLES.forEach(fetchCliniciansByRole);
    fetchFacilityDetails();
  }, [fetchCliniciansByRole, fetchFacilityDetails]); // Use the memoize

  
  const sanitizeEmbryoCulture = (values: EmbryoCultureType): EmbryoCultureType => {
    const sanitizedValues = { ...values };
    if (sanitizedValues.time && sanitizedValues.time.trim().length === 5) {
      sanitizedValues.time = `${sanitizedValues.time}:00`;
    }
  
    sanitizedValues.day = 3; 
    sanitizedValues.cycle = selectedCycleId; 
    return sanitizedValues;
  };
  
  const sanitizeEmbryoDetails = (values: EmbryoUpdateDetailsType, freezedetails?: freezelocationDetails): EmbryoUpdateDetailsType => {
    const sanitizedValues = { ...values };
    sanitizedValues.cycle = selectedCycleId;
    sanitizedValues.status = 'FINALIZED';
    if (sanitizedValues.action === 'FREEZE' && freezedetails) {
      sanitizedValues.cryo_preserved_date = freezeValues.cryo_preserved_date || sanitizedValues.cryo_preserved_date;
      sanitizedValues.cryo_preserved_by = freezeValues.cryo_preserved_by || sanitizedValues.cryo_preserved_by;
      sanitizedValues.cryo_purpose = freezeValues.cryo_purpose || sanitizedValues.cryo_purpose;
      sanitizedValues.cryo_media = freezeValues.cryo_media || sanitizedValues.cryo_media;
      sanitizedValues.is_screened = freezeValues.is_screened || sanitizedValues.is_screened;
      sanitizedValues.locations = freezedetails.cryotech ?? null;
      sanitizedValues.embryos = [freezedetails.embryo_number];
    }

    sanitizedValues.source = selectedSourceId;
    sanitizedValues.thaw_cycle = selectedThawId;

    // ✅ Add the uploaded files in the required format
    if (uploadedFiles.length > 0) {
      sanitizedValues.files = uploadedFiles.map(file => ({
        embryo_no: file.embryo_no,
        file: file.base64.replace(/^data:image\/\w+;base64,/, '') // Remove prefix
      }));
    }

    // Patch facility-based result fields into pgt_results
    if (selectedFacility && Array.isArray(selectedFacility.result_fields)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const pgt_results: Record<string, any> = {};
      selectedFacility.result_fields.forEach((field) => {
        // Use the original field name as key (to match your example)
        const key = field;
        // Try both normalized and original keys for value
        const normalizedKey = field.toLowerCase().replace(/\s+/g, '_');
        let val = ((values as unknown) as Record<string, unknown>)[key];
        if (val === undefined) {
          val = ((values as unknown) as Record<string, unknown>)[normalizedKey];
        }
        if (val === undefined) {
          val = ((values as unknown) as Record<string, unknown>)[`pgt_result_${normalizedKey}`];
        }
        if (val !== undefined && val !== '') {
          pgt_results[key] = val;
        } else {
          pgt_results[key] = '';
        }
      });
      // Always add notes if present
      if (values.pgt_result_notes !== undefined && values.pgt_result_notes !== '') {
        pgt_results['notes'] = values.pgt_result_notes;
      }
      // Ensure pgt_results is a plain object, not an object with nested objects/arrays
      // If you need to render this in React, convert to string or handle in the UI
      sanitizedValues.pgt_results = pgt_results as unknown as typeof sanitizedValues.pgt_results;
    }

    console.log('Sanitized Embryo Details:', sanitizedValues);

    return sanitizedValues;
  };

  const handleSubmit = async (
    values: { embryoCulture: EmbryoCultureType; embryoDetails: EmbryoUpdateDetailsType },
    { setSubmitting, setErrors, resetForm }: FormikHelpers<{
      embryoCulture: EmbryoCultureType;
      embryoDetails: EmbryoUpdateDetailsType;
    }>
  ) => {
    // Destructure embryoDetails for easy access
    const { pgt_facility, pgt_order_date } = values.embryoDetails;

    // If pgt_facility is not null/undefined and pgt_order_date is null/undefined, set today's date
    if (pgt_facility && !pgt_order_date) {
      const today = new Date().toISOString().split('T')[0]; // Format: YYYY-MM-DD
      values.embryoDetails.pgt_order_date = today;
      console.log('Assigned today\'s date to pgt_order_date:', today);
    }

    showLoader();
    if (freezeLocations){
      
      for (const location of freezeLocations) {
        const updatedFreezeValues = {
          goblet: location.goblet,
          goblet_color: location.goblet_color,
          cryotech: location.cryotech,
          cryotech_color: location.cryotech_color,
          embryo_number:location.embryo_number
        };
    
        // Inject these freeze values into your sanitize function
        const sanitizedEmbryoDetails = sanitizeEmbryoDetails({
          ...values.embryoDetails,
        }, updatedFreezeValues);
    
        const sanitizedEmbryoCulture = sanitizeEmbryoCulture({
          ...values.embryoCulture,
        });
        
    
        if (sanitizedEmbryoDetails.action === 'FREEZE') {
          const tank = location.plan;
    
          // Goblet color
          if (tank && location.goblet != null && location.goblet_color) {
            await storeGobletColor(tank, location.goblet, location.goblet_color)
              .then((response) => {
                console.log('Goblet color successfully stored.', response);
              })
              .catch((error) => {
                console.error('Error storing goblet color:', error);
              });
          } else {
            console.warn('Tank, Goblet, or Goblet Color is missing.');
          }
    
          // Cryotech color
          if (tank && location.cryotech != null && location.cryotech_color) {
            await storeGobletColor(tank, location.cryotech, location.cryotech_color)
              .then((response) => {
                console.log('Cryotech color successfully stored.', response);
              })
              .catch((error) => {
                console.error('Error storing cryotech color:', error);
              });
          } else {
            console.warn('Tank, Cryotech, or Cryotech Color is missing.');
          }
        }
  
        await Promise.all([
          
          updateEmbryoCulture(values.embryoCulture.id ?? 0, sanitizedEmbryoCulture),
          updateEmbryoSummary(selectedCycleId, sanitizedEmbryoDetails),
        ])
          .then(([updatedEmbryoCulture, updatedEmbryoDetails]) => {
            addAlert(tGeneral('embryoSavedSuccess', { embryoNumber: location.embryo_number, defaultValue: 'Embryo {{embryoNumber}} saved successfully' }), 'success');
    
            // Reset form after each iteration if needed
            resetForm({
              values: {
                embryoCulture: sanitizedEmbryoCulture,
                embryoDetails: initialEmbryoUpdateDetailsValues,
              },
            });
    
            fetchEmbryoDetails(selectedCycleId, selectedSourceId ?? undefined, selectedThawId);
            fetchSourceList();
            setSelectedEmbryos([]);
          })
          .catch((error: unknown) => {
            if (error instanceof AxiosError) {
              if (error.response?.data?.type === 'validation_error') {
                const apiErrors = error.response.data.errors;
    
                const formikErrors: FormikErrors<{
                  embryoCulture: EmbryoCultureType;
                  embryoDetails: EmbryoUpdateDetailsType;
                }> = {
                  embryoCulture: {} as FormikErrors<EmbryoCultureType>,
                  embryoDetails: {} as FormikErrors<EmbryoUpdateDetailsType>,
                };
    
                apiErrors.forEach((err: { attr: string | null; detail: string }) => {
                  if (err.attr?.startsWith('embryoCulture')) {
                    const fieldKey = err.attr.replace('embryoCulture.', '');
                    formikErrors.embryoCulture![fieldKey as keyof EmbryoCultureType] = err.detail;
                  } else if (err.attr?.startsWith('embryoDetails')) {
                    const fieldKey = err.attr.replace('embryoDetails.', '');
                    formikErrors.embryoDetails![fieldKey as keyof EmbryoUpdateDetailsType] = err.detail;
                  } else {
                    console.error('Unhandled validation error:', err.detail);
                    addAlert(err.detail, 'error');
                  }
                });
    
                setErrors(formikErrors);
              } else {
                console.error('Unexpected error occurred:', error);
              }
            } else {
              console.error('Error occurred while saving embryo details:', error);
            }
          }).finally(() => {
            hideLoader();
            setSubmitting(false);
          });
      }
    }else{
      const sanitizedEmbryoCulture = sanitizeEmbryoCulture(values.embryoCulture);
      const sanitizedEmbryoDetails = sanitizeEmbryoDetails(values.embryoDetails); 
      Promise.all([
        updateEmbryoCulture(values.embryoCulture.id ?? 0, sanitizedEmbryoCulture),
        updateEmbryoSummary(selectedCycleId, sanitizedEmbryoDetails),
      ]
      )
        .then(([updatedEmbryoCulture, updatedEmbryoDetails]) => {
          addAlert(tGeneral('embryoDetailsSavedSuccess', { defaultValue: 'Embryo details saved successfully' }), 'success');
       
          // Reset form with sanitized values
          resetForm({
            values: {
              embryoCulture: sanitizedEmbryoCulture,
              embryoDetails: initialEmbryoUpdateDetailsValues,
            },
          });
       
          // fetchEmbryoDetails(selectedCycleId ?? 0); 
  
          fetchEmbryoDetails(selectedCycleId,  selectedSourceId ?? undefined, selectedThawId);
          fetchSourceList(); 
          setSelectedEmbryos([]);
        })
        .catch((error: unknown) => {
          // Handle errors
          if (error instanceof AxiosError) {
            if (error.response?.data?.type === 'validation_error') {
              const apiErrors = error.response.data.errors;
       
              const formikErrors: FormikErrors<{
                   embryoCulture: EmbryoCultureType;
                   embryoDetails: EmbryoUpdateDetailsType;
                 }> = {
                   embryoCulture: {} as FormikErrors<EmbryoCultureType>,
                   embryoDetails: {} as FormikErrors<EmbryoUpdateDetailsType>,
                 };
  
              apiErrors.forEach((err: { attr: string | null; detail: string }) => {
                if (err.attr && err.attr.startsWith('embryoCulture')) {
                  const fieldKey = err.attr.replace('embryoCulture.', '');
                    formikErrors.embryoCulture![fieldKey as keyof EmbryoCultureType] = err.detail;
                } else if (err.attr && err.attr.startsWith('embryoDetails')) {
                  const fieldKey = err.attr.replace('embryoDetails.', '');
                    formikErrors.embryoDetails![fieldKey as keyof EmbryoUpdateDetailsType] = err.detail;
                } else {
                  console.error('Unhandled validation error:', err.detail);
                  
                  addAlert(err.detail, 'error');
                }
              });
       
              setErrors(formikErrors);
            } else {
              console.error('Unexpected error occurred:', error);
            }
          } else {
            console.error('Error occurred while saving embryo details:', error);
          }
        })
        .finally(() => {
          hideLoader();
          setSubmitting(false);
        });
    }
  };
  
  
  const handleDelete = (id: number | string) => {
    setRows((prevRows) => prevRows.filter((row) => row.id !== id));
    // fetchEmbryoDetails(selectedCycleId); 
    fetchSourceList(true);

  };


  const handleFreezeDialogSave = (formValues: FreezeDialogValues, selectedfreezedEmbryosDetails: freezelocationDetails[]) => {
    setFreezeValues(formValues); 
    setFreezelocations(selectedfreezedEmbryosDetails);
    setFreezeDialogOpen(false);
  };
  
  const saveFinalize = () => {
    const finalizePromises = sourceData.map((source) => {
      // Filter embryos that match the current source
      const filteredEmbryos = allSourceEmbryos
        .filter((embryo) => embryo.source === source.source && embryo.thaw_cycle === source.thaw_cycle)
        .map((embryo) => embryo.embryo_number);

      const payload: EmbryoFinilizeUpdateType = {
        embryos: filteredEmbryos,  
        cycle: selectedCycleId as number,
        day: 3, 
        status: 'FINALIZED',
        source:source.source,
        thaw_cycle:source.thaw_cycle
      };
      return updateEmbryoSummary(selectedCycleId, payload)
        .then(() => {
          addAlert(tGeneral('embryoDetailsSavedForSource', { sourceName: source.name, defaultValue: 'Embryo details for source {{sourceName}} saved successfully' }), 'success');
        })
        .catch((error) => {
          console.error(`Error finalizing embryo summary for source ${source.name}:`, error);
        });
    }); 
    Promise.all(finalizePromises).then(() => {
      fetchSourceList();
    }); 

  };


  const handleUploadComplete = (files: { embryo_no: number; base64: string }[]) => {
    setUploadedFiles(files);
  };
  
  
  if (!canView) {
    return <GradingUnavailable message={tGeneral('youDoNotHaveAccessToViewPage', { defaultValue: 'You do not have access to view this page.' })} />;
  }

  if (showViewMode) {
    return (
      <div >
        <EmbryoCultureViewMode data={embryoCulture} tableData={rows} isFinalized ={isTableDeletable} tablecolumns= {getColumns(tGeneral)} day={3} setIsEditMode={setShowViewMode}/>
      </div>
    );
  };

  return (    
    <ThemeProvider theme={theme}>
      {!(canAdd || canEdit) ? (
        <GradingUnavailable message={tGeneral('accessDeniedSaveData', { defaultValue: 'You do not have access to save data.' })} />
      ) : allEmbryos.length === 0 ? (
        <GradingUnavailable message={tCulture('noEmbryosAvailable', { defaultValue: 'No embryos available for the selected day.' })} />
      ) : (
        <Formik
          initialValues={{ 
            embryoCulture: { 
              ...embryoCulture, 
              time: !embryoCulture.time ? getCurrentTimeHHMM() : embryoCulture.time, // Set current time only if empty
            }, 
            embryoDetails 
          }} 
          validationSchema={CombinedValidationSchema(tGeneral)}
          onSubmit={handleSubmit}
          enableReinitialize={false}
        >
          {({
            values,
            setFieldValue,
            submitForm,
            validateForm,
            setFieldTouched,
            errors,
            touched,
            handleBlur,
            handleChange,
          }) => {
            return (
              <Form onSubmit={submitForm}>
                <Grid2 container spacing={2} marginTop={2}>
                  <Grid2 size={{xs:12, sm:3, md:3}}>
                    <TextField
                      name="date"
                      type="date"
                      label={RequiredLabel(tGeneral('Date', { defaultValue: 'Date' }), true)}
                      value={getIn(values, 'embryoCulture.opu_date') || ''}                       
                      disabled
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      defaultValue={new Date().toISOString().split('T')[0]} 
      
                    />
                  </Grid2>
                  <Grid2 size={{xs:12, sm:3, md:3}}>
                    <TextField
                      name="embryoCulture.time"
                      type="time"
                      label={RequiredLabel(tGeneral('time', { defaultValue: 'Time' }), true)}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      value={getIn(values, 'embryoCulture.time') || ''} 
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        !!getIn(touched, 'embryoCulture.time') &&
                            !!getIn(errors, 'embryoCulture.time')
                      }
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      fullWidth
                      size="small"
                      id="embryologist"
                      options={clinicianLists['EMBRYOLOGIST'] || []}
                      getOptionLabel={(option) => `${option.first_name || ''} ${option.last_name || ''}`}
                      value={clinicianLists['EMBRYOLOGIST'].find(
                        (doctor) => doctor.id === values.embryoCulture?.embryologist
                      ) || null}
                      onChange={(_, value) => {
                        setFieldValue('embryoCulture.embryologist', value?.id || ''); // Update Formik's value for 'embryoCulture.embryologist'
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('embryologist', { defaultValue: 'Embryologist' }), true)}
                          error={
                            !!getIn(touched, 'embryoCulture.embryologist') &&
                                !!getIn(errors, 'embryoCulture.embryologist')
                          }
                        />
                      )}
                    />
                  </Grid2>
                    
                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      fullWidth
                      size="small"
                      id="witness"
                      options={clinicianLists['EMBRYOLOGIST'] || []}
                      getOptionLabel={(option) => (option.first_name || '') + ' ' + (option.last_name || '')}
                      value={clinicianLists['EMBRYOLOGIST'].find(
                        (doctor) => doctor.id === values.embryoCulture?.witness
                      ) || null}
                      onChange={(_, value) => {
                        setFieldValue('embryoCulture.witness', value?.id || '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('witness', { defaultValue: 'Witness' }), true)}
                          error={
                            !!getIn(touched, 'embryoCulture.witness') &&
                                !!getIn(errors, 'embryoCulture.witness')
                          }
                          helperText={
                            getIn(touched, 'embryoCulture.witness') && getIn(errors, 'embryoCulture.witness')
                              ? getIn(errors, 'embryoCulture.witness') === tGeneral('witnessEmbryologistNameIsRequired')
                                ? '': getIn(errors, 'embryoCulture.witness') : ''
                          }
                        />
                      )}
                    />
                  </Grid2>
      
                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      options={incubatorsDropdown}
                      //getOptionLabel={(option) => option.label}
                      getOptionLabel={(option) => tGeneral(option.name)}
                      value={
                        incubatorsDropdown.find(
                          (option) => option.id === getIn(values, 'embryoCulture.incubator')
                        ) || null
                      }
                      onChange={(_, value) => {
                        setFieldValue('embryoCulture.incubator', value?.id || '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('incubator', { defaultValue: 'Incubator' }), false)}
                          error={
                            !!getIn(touched, 'embryoCulture.incubator') &&
                                !!getIn(errors, 'embryoCulture.incubator')
                          }
                        />
                      )}
                    />
                  </Grid2>

                
                
      
                  <Grid2 size={{ xs: 12, sm: 3, md: 3 }}>
                    <TextField
                      name="remarks"
                      label={RequiredLabel(tGeneral('remark', { defaultValue: 'Remark' }), false)}
                      fullWidth
                      multiline
                      rows={1}
                      placeholder={tGeneral('enterRemark', { defaultValue: 'Enter remark' })}
                      value={values.embryoCulture?.remarks || ''}
                      onChange={(e) => {
                        setFieldValue('embryoCulture.remarks', e.target.value || '');
                      }}
                      onBlur={handleBlur}
                      error={
                        !!getIn(touched, 'embryoCulture.remarks') &&
                            !!getIn(errors, 'embryoCulture.remarks')
                      }
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      options={dropDownMaster?.culture_dish_config}
                      getOptionLabel={(option) => option.label}
                      value={
                        dropDownMaster?.culture_dish_config.find(
                          (option) => option.value === getIn(values, 'embryoCulture.culture_dish_config')
                        ) || null
                      }
                      onChange={(_, value) => {
                        setFieldValue('embryoCulture.culture_dish_config', value?.value || '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('cultureDishConfig', { defaultValue: 'Culture Dish Configuration' }), false)}
                          error={
                            !!getIn(touched, 'embryoCulture.culture_dish_config') &&
                            !!getIn(errors, 'embryoCulture.culture_dish_config')
                          }
                        />
                      )}
                    />
                  </Grid2>

                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={getIn(values, 'embryoCulture.is_assisted_hatching') || false}
                          onChange={(e) =>
                            setFieldValue('embryoCulture.is_assisted_hatching', e.target.checked)
                          }
                        />
                      }
                      label={tGeneral('assistedHatching', { defaultValue: 'Assisted Hatching' })}
                    />
                  </Grid2>
      
                </Grid2>   
      
      
                <div>
                  <OocyteSelector
                    title={tGeneral('embryoNo', { defaultValue: 'Embryo No.'})}
                    sourceList={sourceData}
                    selectedsource={selectedSource}
                    totalOocytes={allEmbryos}
                    onSelectionChange={handleSelectionChange}
                    hitSubmitbtn={hitSubmitbtn}
                  />
                </div>
                <Grid2 container spacing={2} marginTop={2}>
                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      options={dropDownMaster?.embryoDetails_grade}
                      getOptionLabel={(option) => option.label}
                      value={
                        dropDownMaster?.embryoDetails_grade.find(
                          (option) => option.value === getIn(values, 'embryoDetails.grade')
                        ) || null 
                      }
                      onChange={(_, value) => {
                        setFieldValue('embryoDetails.grade', value?.value || '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('grade', { defaultValue: 'Grade' }), false)}
                          error={
                            !!getIn(touched, 'embryoDetails.grade') &&
                                !!getIn(errors, 'embryoDetails.grade')
                          }
                        />
                      )}
                    />
                  </Grid2>

                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      options={symmetryItems}
                      getOptionLabel={(option) => tGeneral(option.label)}
                      value={
                        symmetryItems.find(
                          (option) => option.value === getIn(values, 'embryoDetails.symmetry')
                        ) || null
                      }
                      onChange={(_, value) => {
                        setFieldValue('embryoDetails.symmetry', value?.value || '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('symmetry', { defaultValue: 'Symmetry' }), false)}
                          error={
                            !!getIn(touched, 'embryoDetails.symmetry') &&
                                !!getIn(errors, 'embryoDetails.symmetry')
                          }
                        />
                      )}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      options={dropDownMaster?.number_of_cells}
                      getOptionLabel={(option) => option.label}
                      value={
                        dropDownMaster?.number_of_cells.find(
                          (option) => option.value === getIn(values, 'embryoDetails.number_of_cells')
                        ) || null
                      }
                      onChange={(_, value) => {
                        setFieldValue('embryoDetails.number_of_cells', value?.value || '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('numberOfCells', { defaultValue: '# Cells' }), false)}
                          error={
                            !!getIn(touched, 'embryoDetails.number_of_cells') &&
                                          !!getIn(errors, 'embryoDetails.number_of_cells')
                          }
                        />
                      )}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      options={dropDownMaster?.embryoDetails_multi_nuclei}
                      getOptionLabel={(option) => option.label}
                      value={
                        dropDownMaster?.embryoDetails_multi_nuclei.find(
                          (option) => option.value === getIn(values, 'embryoDetails.multi_nuclei')
                        ) || null
                      }
                      onChange={(_, value) => {
                        setFieldValue('embryoDetails.multi_nuclei', value?.value || '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('multinuclei', { defaultValue: 'Multinuclei' }), false)}
                          error={
                            !!getIn(touched, 'embryoDetails.multi_nuclei') &&
                                !!getIn(errors, 'embryoDetails.multi_nuclei')
                          }
                        />
                      )}
                    />
                  </Grid2>

                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }}>
                    <Autocomplete
                      options={pgtorderDetailsItems}
                      getOptionLabel={(option) => tGeneral(option.label)}
                      value={
                        pgtorderDetailsItems.find(
                          (option) => option.value === getIn(values, 'embryoDetails.pgt_order_details')
                        ) || null
                      }
                      onChange={(_, value) => {
                        setFieldValue('embryoDetails.pgt_order_details', value?.value || '');
                        if (value?.value === 'YES') {
                          setDialogOpen(true);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('pgtOrderDetailsTitle', { defaultValue: 'PGT Order Details' }), false)}
                          error={
                            !!getIn(touched, 'embryoDetails.pgt_order_details') &&
          !!getIn(errors, 'embryoDetails.pgt_order_details')
                          }
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {params.InputProps.endAdornment}
                                {getIn(values, 'embryoDetails.pgt_order_details') === 'YES' && (
                                  <IconButton
                                    onClick={() => setDialogOpen(true)}
                                    edge="end"
                                    size="small"                                    
                                    sx={{ height: '20px', width: '20px'}}
                                  >
                                    <VisibilityIcon />
                                  </IconButton>
                                )}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid2>


                  <Dialog open={isDialogOpen} 
                    onClose={() => {
                      setFieldValue('embryoDetails.pgt_order_details', '');
                      setDialogOpen(false);
                    }}                     
                    maxWidth="md" fullWidth 
                    sx={{
                      '& .MuiDialog-paper': {
                        borderRadius: '20px',
                      },
                 
                    }}>
                    <DialogTitle>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '8px', fontWeight:600, fontFamily:'Montserrat', fontSize:'20px' }}>{tGeneral('pgtOrderDetailsTitle', { defaultValue: 'PGT Order Details' })}</span>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          {selectedEmbryos.map((num) => (
                            <div
                              key={num}
                              style={{
                                width: '24px',
                                height: '24px',
                                borderRadius: '50%',
                                backgroundColor: '#47B35F',
                                color: 'white',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '12px',
                                fontWeight: 400,
                              }}
                            >
                              {num}
                            </div>
                          ))}
                        </div>
                      </div>
                    </DialogTitle>
                    <DialogContent>
                      <Grid2 container spacing={2} marginTop={2}>
                        <Grid2 size={{xs:12, sm:12, md:6}}>
                          <TextField
                            name="embryoDetails.pgt_order_date"
                            label={RequiredLabel(tGeneral('Date', { defaultValue: 'Date' }), true)}
                            fullWidth
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={values.embryoDetails.pgt_order_date }  // Use the value from Formik state or default to today's date
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={!!getIn(touched, 'pgt_order_date') && !!getIn(errors, 'pgt_order_date')}  // Check for errors in the Formik state
                            helperText={getIn(touched, 'pgt_order_date') && getIn(errors, 'pgt_order_date')}
                            defaultValue={new Date().toISOString().split('T')[0]}       

                          />
                        </Grid2>

                        <Grid2 size={{xs:12, sm:12, md:6}}>
                          <TextField
                            name="embryoDetails.pgt_order_time"
                            type="time"
                            label={RequiredLabel(tGeneral('time', { defaultValue: 'Time' }), true)}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            value={getIn(values, 'embryoDetails.pgt_order_time') || ''} 
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={
                              !!getIn(touched, 'embryoDetails.pgt_order_time') &&
                            !!getIn(errors, 'embryoDetails.pgt_order_time')
                            }
                          />
                        </Grid2>

                        <Grid2 size={{ xs:12, sm:12, md:6}} >
                          <Autocomplete
                            options={pgtOrderBiopsyCellsItems}
                            getOptionLabel={(option) => option.label}
                            value={
                              pgtOrderBiopsyCellsItems.find(
                                (option) => option.value === getIn(values, 'embryoDetails.pgt_order_biopsy_cells')
                              ) || null
                            }
                            onChange={(_, value) => {
                              setFieldValue('embryoDetails.pgt_order_biopsy_cells', value?.value || '');
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={RequiredLabel(tGeneral('cellBiopsy', { defaultValue: '# Cell Biopsy' }), false)}
                                error={
                                  !!getIn(touched, 'embryoDetails.pgt_order_biopsy_cells') &&
                                !!getIn(errors, 'embryoDetails.pgt_order_biopsy_cells')
                                }
                              />
                            )}
                          />
                        </Grid2>
                        <Grid2 size={{ xs:12, sm:12, md:6}} >
                          <Autocomplete
                            options={dropDownMaster?.pgtType}
                            getOptionLabel={(option) => option.label}
                            value={
                              dropDownMaster?.pgtType.find(
                                (option) => option.value === getIn(values, 'embryoDetails.pgt_type')
                              ) || null
                            }
                            onChange={(_, value) => {
                              setFieldValue('embryoDetails.pgt_type', value?.value || '');
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}                             
                                label={RequiredLabel(tGeneral('pgtType', { defaultValue: 'PGT Type' }),false)}
                                error={
                                  !!getIn(touched, 'embryoDetails.pgt_type') &&
                                !!getIn(errors, 'embryoDetails.pgt_type')
                                }
                              />
                            )}
                          />
                        </Grid2>
                        
                        <Grid2 size={{ xs:12, sm:12, md:6}} >
                          <Autocomplete
                            options={facilityItems}
                            getOptionLabel={(option) => option.label}
                            value={
                              facilityItems.find(
                                (option) => option.value === getIn(values, 'embryoDetails.pgt_facility')
                              ) || null
                            }
                            onChange={(_, value) => {
                              setFieldValue('embryoDetails.pgt_facility', value?.value || '');
                              // Find and set the selected facility object
                              const facilityObj = facilityObjects.find((f) => f.id === value?.value) || null;
                              setSelectedFacility(facilityObj);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={RequiredLabel(tGeneral('facility', { defaultValue: 'Facility' }),false)}
                                error={
                                  !!getIn(touched, 'embryoDetails.pgt_facility') &&
                                                                                !!getIn(errors, 'embryoDetails.pgt_facility')
                                }
                              />
                            )}
                          />
                        </Grid2>
                        
                      </Grid2>
                    </DialogContent>
                    <DialogActions>
                      <button onClick={handleDialogClose} className={styles.resetButton}>
                        {tGeneral('close', { defaultValue: 'Close' })}
                      </button>
                      <button onClick={handleDialogClose} className={`${styles.customButton}`}>
                        {tGeneral('save', { defaultValue: 'Save' })}
                      </button>
                    </DialogActions>
                  </Dialog>

                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      options={pgtorderDetailsItems}
                      getOptionLabel={(option) => tGeneral(option.label)}
                      value={
                        pgtorderDetailsItems.find(
                          (option) => option.value === getIn(values, 'embryoDetails.pgt_result')
                        ) || null
                      }
                      onChange={(_, value) => {
                        setFieldValue('embryoDetails.pgt_result', value?.value || '');
    
                        // Open dialog only when selecting 'YES'
                        if (value?.value === 'YES') {
                          setIsPGTResultDialogOpen(true);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('PGTResult', { defaultValue: 'PGT Result' }), false)}
                          error={
                            !!getIn(touched, 'embryoDetails.pgt_result') &&
                            !!getIn(errors, 'embryoDetails.pgt_result')
                          }
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {params.InputProps.endAdornment}
                                {getIn(values, 'embryoDetails.pgt_result') === 'YES' && (
                                  <IconButton
                                    onClick={() => setIsPGTResultDialogOpen(true)}
                                    edge="end"
                                    size="small"
                                    sx={{ height: '20px', width: '20px'}}
                                  >
                                    <VisibilityIcon />
                                  </IconButton>
                                )}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid2>



                  <Dialog open={isPGTResultDialogOpen} 
                    onClose={() => {
                      // setFieldValue('embryoDetails.pgt_result', '');
                      setIsPGTResultDialogOpen(false);
                    }}  
                    maxWidth="md" fullWidth 
                    sx={{
                      '& .MuiDialog-paper': {
                        borderRadius: '20px',
                      },
                 
                    }}>
                    <DialogTitle>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '8px', fontWeight:600, fontFamily:'Montserrat', fontSize:'20px' }}> {tGeneral('PGTResult', { defaultValue: 'PGT Result' })}</span>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          {selectedEmbryos.map((num) => (
                            <div
                              key={num}
                              style={{
                                width: '24px',
                                height: '24px',
                                borderRadius: '50%',
                                backgroundColor: '#47B35F',
                                color: 'white',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '12px',
                                fontWeight: 400,
                              }}
                            >
                              {num}
                            </div>
                          ))}
                        </div>
                      </div>
                    </DialogTitle>
                    <DialogContent>
                      <Grid2 container spacing={2} marginTop={2}>
                        {selectedFacility && Array.isArray(selectedFacility.result_fields)
                          ? selectedFacility.result_fields.map((field) => (
                            <Grid2 size={{ xs:12, sm:12, md:6}} key={field}>
                              <TextField
                                name={`embryoDetails.${field}`}
                                label={convertUnderscoreToTitle(field)}
                                fullWidth
                                value={getIn(values, `embryoDetails.${field}`) || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={
                                  !!getIn(touched, `embryoDetails.${field}`) &&
                                    !!getIn(errors, `embryoDetails.${field}`)
                                }
                                helperText={
                                  getIn(touched, `embryoDetails.${field}`) &&
                                    getIn(errors, `embryoDetails.${field}`)
                                }
                              />
                            </Grid2>
                          ))
                          : (
                        // fallback to default fields if no facility or no result_fields
                            <>
                              <Grid2 size={{ xs:12, sm:12, md:6}} >
                                <Autocomplete
                                  options={pgtResultEmbryoSexItems}
                                  getOptionLabel={(option) => tGeneral(option.label)}
                                  value={
                                    pgtResultEmbryoSexItems.find(
                                      (option) => option.value === getIn(values, 'embryoDetails.pgt_result_embryo_sex')
                                    ) || null
                                  }
                                  onChange={(_, value) => {
                                    setFieldValue('embryoDetails.pgt_result_embryo_sex', value?.value || '');
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label={RequiredLabel(tGeneral('embryoSex', { defaultValue: 'Embryo Sex' }), false)}
                                      error={
                                        !!getIn(touched, 'embryoDetails.pgt_result_embryo_sex') &&
                                        !!getIn(errors, 'embryoDetails.pgt_result_embryo_sex')
                                      }
                                    />
                                  )}
                                />
                              </Grid2>
                              <Grid2 size={{ xs:12, sm:12, md:6}} >
                                <Autocomplete
                                  options={pgtResultsItems}
                                  getOptionLabel={(option) => tGeneral(option.label)}
                                  value={
                                    pgtResultsItems.find(
                                      (option) => option.value === getIn(values, 'embryoDetails.pgt_results')
                                    ) || null
                                  }
                                  onChange={(_, value) => {
                                    setFieldValue('embryoDetails.pgt_results', value?.value || '');
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label={RequiredLabel(tGeneral('result', { defaultValue: 'Result' }), false)}
                                      error={
                                        !!getIn(touched, 'embryoDetails.pgt_results') &&
                                        !!getIn(errors, 'embryoDetails.pgt_results')
                                      }
                                    />
                                  )}
                                />
                              </Grid2>
                              <Grid2 size={{ xs:12, sm:12, md:6}} >
                                <Autocomplete
                                  options={pgtResultMoistureItems}
                                  getOptionLabel={(option) => tGeneral(option.label)}
                                  value={
                                    pgtResultMoistureItems.find(
                                      (option) => option.value === getIn(values, 'embryoDetails.pgt_result_moisture')
                                    ) || null
                                  }
                                  onChange={(_, value) => {
                                    setFieldValue('embryoDetails.pgt_result_moisture', value?.value || '');
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label={RequiredLabel(tGeneral('mitosure', { defaultValue: 'Mitosure' }), false)}
                                      error={
                                        !!getIn(touched, 'embryoDetails.pgt_result_moisture') &&
                                        !!getIn(errors, 'embryoDetails.pgt_result_moisture')
                                      }
                                    />
                                  )}
                                />
                              </Grid2>
                            </>
                          )
                        }
                        <Grid2 size={{ xs:12, sm:12, md:6}} >
                          <TextField
                            name="embryoDetails.pgt_result_notes"
                            label={RequiredLabel(tGeneral('notes', { defaultValue: 'Notes' }), false)}
                            fullWidth
                            multiline
                            rows={1}
                            value={values.embryoDetails?.pgt_result_notes || ''}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={
                              !!getIn(touched, 'embryoDetails.pgt_result_notes') &&
                              !!getIn(errors, 'embryoDetails.pgt_result_notes')
                            }
                          />
                        </Grid2>
                      </Grid2>

                    </DialogContent>
                    <DialogActions>
                      <button onClick={handlePGTResultDialogClose} className={styles.resetButton}>
                        {tGeneral('close', { defaultValue: 'Close' })}
                      </button>
                      <button onClick={handlePGTResultDialogClose} className={`${styles.customButton}`}>
                        {tGeneral('save', { defaultValue: 'Save' })}
                      </button>
                    </DialogActions>
                  </Dialog>

                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      options={actionsItems}
                      getOptionLabel={(option) => tGeneral(option.label)}
                      value={
                        actionsItems.find(
                          (option) => option.value === getIn(values, 'embryoDetails.action')
                        ) || null
                      }
                      onChange={(_, value) => {
                        setFieldValue('embryoDetails.action', value?.value || '');
                        if (value?.value === 'FREEZE') {
                          setFreezeDialogOpen(true);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('action', { defaultValue: 'Action' }), true)}
                          slotProps={getFreezeSlotProps(params, values, setFreezeDialogOpen)}
                          error={
                            !!getIn(touched, 'embryoDetails.action') &&
                                          !!getIn(errors, 'embryoDetails.action')
                          }
                        />
                      )}
                    />
                  </Grid2>

                  <Grid2 size={{ xs: 2, sm: 2, md: 2, lg: 2 }}>
                    {/* <EmbryoFileUpload selectedEmbryos={selectedEmbryos} onFileUpload={setFile} imagePathUrl={imagePathUrl} cycle_id={selectedCycleId || null} day={3}/> */}
                    
                    <Grid2 size={{ xs: 2, sm: 2, md: 2, lg: 2 }}>   
                      <Button
                        variant="outlined"
                        component="span"
                        onClick={() => setEmbryoUploadDialogOpen(true)} // Open dialog on click
                        style={{
                          width: '10rem',
                          height: '36px',
                          padding: '12px 40px',
                          gap: '8px',
                          borderRadius: '10px',
                          background: 'rgba(243, 243, 243, 1)',
                          border: 'none',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <FileUploadOutlinedIcon style={{ width: '20px', marginRight: '8px', color: 'black' }} />
                        <Typography
                          style={{
                            fontFamily: 'Montserrat',
                            fontSize: '16px',
                            fontWeight: '600',
                            lineHeight: '22px',
                            textAlign: 'left',
                            color: 'rgba(80, 80, 80, 1)',
                            textTransform: 'capitalize',
                          }}
                        >
                          {tGeneral('upload', { defaultValue: 'Upload' })}
                        </Typography>
                      </Button>

                      {/* Upload Dialog */}
                      <EmbryoMultiImageUploadDialog 
                        isOpen={isEmbryoUploadDialogOpen} 
                        onClose={() => setEmbryoUploadDialogOpen(false)} 
                        selectedEmbryos={selectedEmbryos} 
                        onUploadComplete={handleUploadComplete} 
                      />
                    </Grid2>
                  </Grid2>
                          
                  {/* Freeze Action Dialog */}
                  <FreezeActionDialog
                    open={isFreezeDialogOpen}
                    onClose={() => {
                      setFieldValue('embryoDetails.action', ''); 
                      setFreezeDialogOpen(false);  
                    }}
                    values={freezeValues}
                    onSave={handleFreezeDialogSave}                    
                    selectedEmbryos={selectedEmbryos}
                    existingFreezeLocations={freezeLocations || undefined}
                    defaultCryoPreservedDate={getIn(values, 'embryoCulture.opu_date') || undefined}
                  />
                  
      
                </Grid2>
      
      
                <div >
                  <p style={{fontFamily:'Montserrat', fontSize:'20px', fontWeight:700, padding:'1rem'}}>{tGeneral('details', { defaultValue: 'Details' })}</p>
                  <DetailsTable columns={getColumns(tGeneral)} rows={rows} isDeletable={!showViewMode}  onDelete={handleDelete}/>
                </div>
                <div>
                  <Box sx={{display:'flex', justifyContent:'space-between'}}>
                    <Box sx={{display:'flex', justifyContent:'flex-start', marginTop:'1rem'}}>
                      {detailFound && (
                        <button
                          type="button"
                          className={styles.resetButton}
                          onClick={() => setShowViewMode(true)}
                        >
                          {tGeneral('Cancel', { defaultValue: 'Cancel' })}
                        </button>
                      )}
                    </Box>
                    <Box className={`${styles.customButtonDiv}`}  > 
                      {/* {!areAllOocytesFilled ? (
                        <button
                          type="button"
                          className={styles.resetButton}
                          style={{width:'10rem',
                            cursor : areAllOocytesFilled ? 'pointer':'not-allowed'
                          }}
                          disabled={!areAllOocytesFilled}
                          onClick={async () => {
                    
                            // Ensure setFieldValue completes before proceeding
                            await setFieldValue('embryoDetails.embryos', selectedEmbryos);
                    
                            setActionStatus('FINALIZED');

                            setHitSubmitbtn(true);
                            console.log('Embryo Details:', embryoDetails);
                    
                            validateForm().then((formErrors) => {
                              // Mark fields with validation errors as touched
                              Object.entries(formErrors).forEach(([namespace, fields]) => {
                                if (fields && typeof fields === 'object') {
                                  Object.keys(fields).forEach((field) => {
                                    setFieldTouched(`${namespace}.${field}`, true, true);
                                  });
                                }
                              });
                    
                              if (Object.keys(formErrors).length === 0) {
                                setOpenConfirmDialog(true);
                              } else {
                                console.log('Validation errors:', formErrors);
                              }
                            });
                          }}
                        >
                      Save & Finalize
                        </button>
                       
                      ) : (
                        <button
                          type="button"
                          style={{ width: '10rem' }}
                          className={styles.resetButton}                          
                          onClick={() => setFinalizeConfirmDialogOpen(true)}
                        >
                          <span style={{ fontWeight: 'bold' }}>
                            {'Save & Finalized'}
                          </span>
                        </button>
                      )} */}

                      <button
                        type="button"
                        onClick={async () => {
                    
                          // Ensure setFieldValue completes before proceeding
                          await setFieldValue('embryoDetails.embryos', selectedEmbryos);
                    
                          setActionStatus('DRAFT');
                          setHitSubmitbtn(true);
                    
                          validateForm().then((formErrors) => {
                          // Mark fields with validation errors as touched
                            Object.entries(formErrors).forEach(([namespace, fields]) => {
                              if (fields && typeof fields === 'object') {
                                Object.keys(fields).forEach((field) => {
                                  setFieldTouched(`${namespace}.${field}`, true, true);
                                });
                              }
                            });
                    
                            if (Object.keys(formErrors).length === 0) {
                              setOpenConfirmDialog(true);
                            } else {
                              console.log('Validation errors:2222', formErrors);
                            }
                          });
                        }}
                    
                        className={`${styles.customButton}`}
                      >
                        <span style={{ fontWeight: 'bold' }}>
                          {tGeneral('save', { defaultValue: 'Save' })}
                        </span>
                      </button>                 
                    </Box>
                  </Box>
                </div>
                  
                <ConfirmationModal
                  open={openConfirmDialog}
                  handleClose={() => setOpenConfirmDialog(false)}
                  onConfirm={() => {
                    setOpenConfirmDialog(false);
                    submitForm(); 
                  }} 
                  type="save"
                  title={tCulture('embryoCulture', { defaultValue: 'Embryo Culture' })}
                  contentMessage={
                    actionStatus === 'FINALIZED'
                      ? tGeneral('confirmFinalizeDay3', { defaultValue: 'Are you sure you want to finalize day 3 details?' })
                      : tGeneral('confirmSaveDay3', { defaultValue: 'Are you sure you want to save day 3 details?' })
                  }
                />

                <ConfirmationModal
                  open={isFinalizeConfirmDialogOpen}
                  handleClose={() => setFinalizeConfirmDialogOpen(false)}
                  onConfirm={() => {
                    setFinalizeConfirmDialogOpen(false);
                    saveFinalize();
                  }} 
                  type="save"
                  title={tCulture('embryoCulture', { defaultValue: 'Embryo Culture' })}
                  contentMessage={ tGeneral('confirmFinalizeDay3', { defaultValue: 'Are you sure you want to finalize day 3 details?' }) }
                />
              </Form>
            );
          }}
        </Formik>
      )}
    </ThemeProvider>
  );
};

export default DayThird;
